<template>
  <div>
    <div v-if="$membershipHasPermissionTo('create campaigns')">
      <BaseButton primary @click="setModalCreateVisible(true)"> New Ad Plan </BaseButton>
    </div>

    <CampaignList
      :loading="pending"
      :project-uuid="projectId"
      :campaigns="campaigns"
      class="mt-4"
      @campaign-delete="removeCampaign"
    />

    <template v-if="$membershipHasPermissionTo('create campaigns')">
      <portal v-if="modalCreateVisible" to="app-dialog">
        <ModalCreate
          close-on-success
          :project-uuid="projectId"
          :action="doStore"
          @closed="setModalCreateVisible(false)"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import CampaignList from '@/components/ProjectCampaign/CampaignList.vue';
import ModalCreate from '@/components/ProjectCampaign/ModalCreate.vue';

export default {
  components: {
    CampaignList,
    ModalCreate,
  },
  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },
  data: () => ({
    pending: false,
    modalCreateVisible: false,
  }),
  computed: {
    ...mapState('ui/projectCampaigns', ['ids']),
    ...mapGetters('ui/projectCampaigns', ['campaigns']),
  },
  created() {
    this.init();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/projectCampaigns', {
      loadCampaigns: 'load',
      storeCampaign: 'store',
    }),
    ...mapActions('ui/campaigns', ['deleteCampaign']),
    ...mapMutations('ui/projectCampaigns', ['setIds', 'setMeta', 'setLinks']),
    async init() {
      const { projectId } = this;

      this.pending = true;

      try {
        const { campaignUuids } = await this.loadCampaigns({
          projectId,
          params: {
            include: [
              'channels',
              'channableData',
              'gaCampaigns.gaAds',
              'gaReportsAggregatedOnCampaignLevel',
              'contactRequestsCount',
              'channelsCount',
            ].join(','),
          },
        });

        if (campaignUuids.length === 1 && !this.$membershipHasPermissionTo('create campaigns')) {
          this.$router.replace({
            name: 'accounts.campaigns.campaignUuid',
            params: {
              accountId: this.accountId,
              campaignUuid: campaignUuids[0],
            },
          });
        } else {
          this.pending = false;
        }
      } catch (error) {
        this.pending = false;
      }
    },
    doStore(params) {
      return this.storeCampaign({ projectId: this.projectId, params });
    },
    setModalCreateVisible(bool) {
      this.modalCreateVisible = bool;
    },
    async removeCampaign(campaignId) {
      try {
        await this.deleteCampaign({ campaignId });

        this.setIds(this.ids.filter((id) => id !== campaignId));

        this.resetAction();
      } catch (error) {
        //
      }
    },
  },
};
</script>
